import { useState } from "react";
import { createContainer } from "unstated-next";
import { RechargeRecordTabType } from "../constants";

export function usePaymentStoreHook() {
  const [activeTabKey, setActiveTabKey] = useState<RechargeRecordTabType>(
    RechargeRecordTabType.Normal
  );

  return { activeTabKey, setActiveTabKey };
}

const PaymentStoreContainer = createContainer(usePaymentStoreHook);
export const PaymentStoreContainerProvider = PaymentStoreContainer.Provider;

export function usePaymentStore() {
  return PaymentStoreContainer.useContainer();
}
